export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/luciana/Projetos/example-mask/src/environments/environment.ts